/**
 * <s-copy-code> — tap-to-copy discount code.
 *
 * Wraps a <button>. Clicking it copies the text of the descendant marked
 * [data-code] to the clipboard and sets [data-copied] on the element for a
 * moment so CSS can show a confirmation. The visible "Copied" text comes from
 * the element's data-copied-label (translated in Liquid) and is announced via
 * the descendant [data-copy-status] live region.
 */
class CopyCode extends HTMLElement {
  #timer = 0;

  connectedCallback() {
    this.addEventListener('click', this.#onClick);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.#onClick);
    clearTimeout(this.#timer);
  }

  #onClick = async (event) => {
    if (!event.target.closest('button')) return;
    const code = this.querySelector('[data-code]')?.textContent.trim();
    if (!code) return;
    try {
      await navigator.clipboard.writeText(code);
    } catch {
      return;
    }
    const status = this.querySelector('[data-copy-status]');
    if (status) status.textContent = this.dataset.copiedLabel ?? '';
    this.setAttribute('data-copied', '');
    clearTimeout(this.#timer);
    this.#timer = setTimeout(() => {
      this.removeAttribute('data-copied');
      if (status) status.textContent = '';
    }, 2000);
  };
}

if (!customElements.get('s-copy-code')) customElements.define('s-copy-code', CopyCode);
